import Collapse from 'bootstrap/js/src/collapse'

class Accordions{
    create(entry){
        new Collapse(entry)
    }
}

export const AccordionManager = new Accordions()